import * as React from 'react'
import { Form } from 'react-bootstrap'
import InputDatePicker from '../../../../components/InputDatePicker'
import { InfractionT } from '../../../../types/JobWorker'
import { copyObject } from '../../../../utils'

interface InfractionProps {
    index: number
    infraction: InfractionT
    removeInfraction(index: number): void,
    updateInfraction(index: number, infraction: InfractionT): void,
}


const Infraction: React.FunctionComponent<InfractionProps> = ({ index, infraction, removeInfraction, updateInfraction }): JSX.Element => {

    const onChangeValue = (key: string, value: any): void => {
        let newInfraction = copyObject(infraction)
        newInfraction[key] = value
        updateInfraction(index, newInfraction)
    }
    return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 30px' }}>
            <span>
                <Form.Label>Date</Form.Label>
                <InputDatePicker
                    id={`infraction-worker-date-${index}`}
                    className="input-material"
                    style={{ width: '100%' }}
                    selectedDate={`${infraction.date ? infraction.date : ""}`}
                    onChangeDate={(val) => {
                        onChangeValue('date', val)

                    }}
                    onChange={(val) => { }}
                    dateFormat="MM/dd/yyyy"
                    placeholder="Date"
                />
            </span>
            <span>
                <Form.Label>Infraction</Form.Label>
                <Form.Control
                    as='select'
                    className='input-material'
                    value={`${infraction.infraction}`}
                    onChange={(event: any) => { onChangeValue('infraction', event.target.value) }}  >
                    <option></option>
                </Form.Control>
            </span>
            <span>
                <Form.Label>Tier</Form.Label>
                <Form.Control
                    as='select'
                    className='input-material'
                    value={`${infraction.tier ? infraction.tier : ''}`}
                    onChange={(event: any) => { onChangeValue('tier', event.target.value) }}>
                    <option></option>
                    <option value='1'>Tier 1</option>
                    <option value='2'>Tier 2</option>
                    <option value='3'>Tier 3</option>
                </Form.Control>
            </span>
            <span>
                <Form.Label>Comments</Form.Label>
                <Form.Control
                    className='input-material'
                    value={`${infraction.comments ? infraction.comments : ''}`}
                    onChange={(event: any) => { onChangeValue('comments', event.target.value) }} />
            </span>
            <span
                onClick={(): void => { removeInfraction(index) }}>
                x
            </span>
        </div>
    )
}

export default Infraction